import { faClipboard } from '@fortawesome/pro-light-svg-icons';
import { getImportQueue } from 'RestAPIs/import-queue';

import { BaseQueue } from 'components/admin-portal/queues/BaseQueue';
import showSnackbar from 'components/shared/Snackbar';
import { useTranslation } from 'react-i18next';

const ImportQueue = () => {
  const columns = [
    'id',
    'tenantId',
    'status',
    'inserted',
    'started',
    'ended',
    'externalId',
    'type',
    'employer'
  ];

  const { t } = useTranslation('common');

  const onClickCopyToClipboardRow = (
    id: string | number,
    importedObject: string | undefined
  ) =>
    navigator.clipboard
      .writeText(importedObject || '')
      .then(() =>
        showSnackbar({
          message: 'Item ' + t('copiedToClipboard', { name: id })
        })
      )
      .catch((error) => {
        console.error('Failed to copy text to clipboard:', error);
      });

  return (
    <BaseQueue
      queueName="importQueue"
      columns={columns}
      getBaseQueue={getImportQueue}
      customActions={(id, row) => [
        {
          tooltipTitle: t('copyToClipboard'),
          icon: faClipboard,
          onClick: () => onClickCopyToClipboardRow(id, row?.importedObject)
        }
      ]}
    />
  );
};

export default ImportQueue;
